import Vue from 'vue';
import LangRouter, { i18n } from 'vue-lang-router';
import Home from '../views/Home.vue';
import OilGasFinderPrintView from '../components/oil-gas-finder/OilGasFinderPrintView.vue';
import translations from '../lang/translations';
import localizedURLs from '../lang/localized-urls';
import { FEED_NOT_SUPPORTED_LANGS } from '../config';

Vue.use(LangRouter, {
  defaultLanguage: 'en',
  translations,
  localizedURLs,
});

function feedEnabledGuard(to, from, next) {
  if (FEED_NOT_SUPPORTED_LANGS.includes(i18n.locale)) {
    next('/');
  } else {
    next();
  }
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/experts',
    name: 'Experts',
    beforeEnter: feedEnabledGuard,
    component: () => import(/* webpackChunkName: "experts" */ '../views/Experts.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/:lang?/material/:slug',
    name: 'Material',
    component: () => import(/* webpackChunkName: "material" */ '../views/Material.vue'),
  },
  {
    path: '/search/:query?',
    name: 'Search',
    component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue'),
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import(/* webpackChunkName: "search" */ '../views/Signup.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "search" */ '../views/Login.vue'),
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "search" */ '../views/UserProfile.vue'),
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: () => import(/* webpackChunkName: "search" */ '../views/ResetPassword.vue'),
  },
  {
    path: '/forgot-password',
    name: 'Forgot Password',
    component: () => import(/* webpackChunkName: "search" */ '../views/ForgotPassword.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import(/* webpackChunkName: "search" */ '../views/PrivacyPolicy.vue'),
  },
  {
    path: '/where-to-buy',
    name: 'Where To Buy',
    component: () => import(/* webpackChunkName: "search" */ '../views/WhereToBuy.vue'),
  },
  {
    path: '/oil-gas-finder',
    name: 'Oil Gas Finder',
    component: () => import(/* webpackChunkName: "oil-gas-finder" */ '../views/OilGasFinder.vue'),
  },
  {
    path: '/oil-gas-finder-print',
    name: 'Oil Gas Finder Print',
    component: OilGasFinderPrintView,
  },
  {
    path: '/404',
    name: 'Page Not Found',
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue'),
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue'),
  },
];

const router = new LangRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash };
    }
    return false;
  },
});

// Check that the back button has been pressed
window.popStateDetected = false;
window.addEventListener('popstate', () => {
  window.popStateDetected = true;
});

router.beforeEach((to, from, next) => {
  if (to.name === 'Material') {
    const { user } = router.app.$store.state;
    if (user.user?.jwt?.payload?.exp) {
      const { exp } = user.user.jwt.payload;
      const now = Math.floor(Date.now() / 1000);
      if (now > exp) {
        // token expired, silently log out
        router.app.$store.dispatch('user/LOGOUT');
      }
    }
  }

  // Post message to mobile app on route change
  if (router.app.$fromApp) {
    const isBackButtonPushed = window.popStateDetected;
    if (isBackButtonPushed) {
      router.app.$historyCount -= 1;
    } else {
      router.app.$historyCount += 1;
    }
    if (router.app.$historyCount === 1) {
      window.ReactNativeWebView.postMessage('firstPageDetected');
    } else {
      window.ReactNativeWebView.postMessage('routeChangeDetected');
    }
  }
  next();
});

export default router;
